import React from "react";

import ActionDropdown from "components/Common/ActionDropdown";
import { Steward, LinkText } from "components/Common/TableStyle";

export const CROSSWALK_TABLE = (handleDelete, userPermissions) => [
  {
    title: "Reference Source",
    key: "reference_source",
    dataIndex: "reference_source",
    width: "40%",
    render: (row, record) => (
      <LinkText text={row.name} link={`${record?.id}/crosswalk-mapping`} />
    ),
  },
  {
    title: "Type",
    key: "crosswalk_type",
    dataIndex: "crosswalk_type",
    width: "12%",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Mapped%",
    key: "mapping",
    dataIndex: "mapping",
    width: "12%",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    width: "12%",
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    width: "12%",
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
    width: "12%",
    align: "center",
    render: (_, record) => (
      <ActionDropdown
        deleteProps={{
          onClick: () => handleDelete(record),
          "data-cy": "crosswalk-delete-button",
        }}
        userPermissions={userPermissions}
      />
    ),
  },
];

export const CROSSWALK_IN_LIST_DUMMY_ROWS_DATA = [
  {
    id: 1,
    name: "DSDE_Source_A_Table_X_Field_2",
    type: "DSDE",
    mapped: "95%",
    drafter: { name: "Debbie Data Stew", role: "role" },
    approver: { name: "Ingrid Info Govern", role: "role" },
  },
];

export const CROSSWALK_OUT_LIST_DUMMY_ROWS_DATA = [
  {
    id: 1,
    name: "HR_Gender",
    type: "Department",
    mapped: "100%",
    drafter: { name: "Debbie Data Stew", role: "role" },
    approver: { name: "Ingrid Info Govern", role: "role" },
  },
];
